/**
 * APM format utilities — frontend (ESM) copy of the subset of
 * backend/apm/format.js used by the client SDK (parseStack + cleanMessage).
 *
 * Kept as a separate file so the client SDK has no runtime dependency on the
 * backend directory. If the backend format.js changes, update this too.
 */

/**
 * Parse a JS stack trace string into normalized frames.
 * @param {string|undefined} stack
 * @returns {Array<{function: string, filename: string, lineno: number, colno: number, inApp?: boolean}>}
 */
export function parseStack(stack) {
  if (!stack) return [];
  const frames = [];
  const lines = stack.split('\n');
  const reChrome = /^\s*at\s+(.+?)\s+\(?(.+?):(\d+):(\d+)\)?$/;
  const reFirefox = /^\s*([^@]+)@(.+?):(\d+):(\d+)/;
  for (const line of lines) {
    const m = line.match(reChrome) || line.match(reFirefox);
    if (!m) continue;
    const fn = (m[1] || '').trim() || '<anonymous>';
    const filename = m[2] || '';
    const lineno = parseInt(m[3] || '0', 10);
    const colno = parseInt(m[4] || '0', 10);
    if (filename.startsWith('node:') || filename.includes('node_modules')) continue;
    frames.push({ function: fn, filename, lineno, colno, inApp: !filename.includes('node:') });
  }
  return frames.slice(0, 10);
}

/**
 * Strip the leading "Error: " / "Uncaught " from stack strings.
 * @param {string} message
 * @returns {string}
 */
export function cleanMessage(message) {
  return message.replace(/^Error:\s*/, '').replace(/^Uncaught\s+/i, '').trim();
}
